import { config } from '../../utils/utils';
import store from '../../store';
import { toastHandler } from '../../utils/toastHandler';

export interface CompanyCreditUsageHistoryItem {
  id: string;
  companyId: string;
  advertiseId: string;
  advertiseTitle: string;
  advertiseNumber: string;
  creditsUsed: number;
  usedAt: string;
  companyName?: string; // For admin views
  companyEmail?: string; // For admin views
}

export interface CompanyCreditUsageHistoryResponse {
  data: CompanyCreditUsageHistoryItem[];
  total: number;
  page: number;
  limit: number;
  summary: {
    totalCreditsUsed: number;
  };
}

/**
 * Get company credit usage history
 */
export const getCompanyCreditUsageHistory = async (
  options?: { page?: number; limit?: number; companyId?: string }
): Promise<CompanyCreditUsageHistoryResponse> => {
  try {
    const { accessToken } = store.getState().auth;

    let url = `${config.BASE_URL}/company-credit-usage-log`;
    const params = new URLSearchParams();

    if (options?.page) {
      params.append('page', options.page.toString());
    }
    if (options?.limit) {
      params.append('limit', options.limit.toString());
    }
    if (options?.companyId) {
      params.append('companyId', options.companyId);
    }

    const queryString = params.toString();
    if (queryString) {
      url = `${url}?${queryString}`;
    }

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch company credit usage history');
    }

    return await response.json();
  } catch (error: any) {
    toastHandler(error);
    throw error;
  }
};

